import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNullOrUndefined } from "et3-type-guards";
import { useState } from "react";

import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";
import {
  SIDE_BAR_ACCENT_RADIUS,
  SIDE_BAR_ACCENT_WIDTH,
  SIDE_BAR_CHEVRON_SIZE,
  SIDE_BAR_GROUP_FONT_SIZE,
  SIDE_BAR_GROUP_GAP,
  SIDE_BAR_GROUP_HEIGHT,
  SIDE_BAR_GROUP_ICON_SIZE,
  SIDE_BAR_GROUP_PADDING_X,
  SIDE_BAR_GROUP_RADIUS,
  SIDE_BAR_LABEL_MUTED,
  SIDE_BAR_ROW_ACTIVE_BACKGROUND,
  SIDE_BAR_ROW_HOVER_BACKGROUND,
  SIDE_BAR_ROW_WIDTH,
  SIDE_BAR_TRANSITION
} from "../side-bar-constants";

const CHEVRON_OPEN_ROTATION = "rotate(180deg)";
const CHEVRON_CLOSED_ROTATION = "rotate(0deg)";

type TSideBarRow = {
  icon: IconProp;
  title: string;
  isActive: boolean;
  isOpen: boolean;
  hasChevron: boolean;
  onPress: () => void;
};

const SideBarRow = withLiteObserverAndTheme<TSideBarRow>((props) => {
  const { icon, title, isActive, isOpen, hasChevron, onPress, theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);

  const backgroundColor = (() => {
    switch (true) {
      case isActive:
        return SIDE_BAR_ROW_ACTIVE_BACKGROUND;
      case isHovered:
        return SIDE_BAR_ROW_HOVER_BACKGROUND;
      default:
        return colors.all.transparent;
    }
  })();

  const contentColor =
    isActive || isHovered ? colors.all.white : SIDE_BAR_LABEL_MUTED;

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onPress()}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        border: 0,
        flexShrink: 0,
        cursor: "pointer",
        backgroundColor,
        width: SIDE_BAR_ROW_WIDTH * unitX,
        height: SIDE_BAR_GROUP_HEIGHT * unitY,
        borderRadius: SIDE_BAR_GROUP_RADIUS * unitX,
        paddingLeft: SIDE_BAR_GROUP_PADDING_X * unitX,
        paddingRight: SIDE_BAR_GROUP_PADDING_X * unitX,
        gap: SIDE_BAR_GROUP_GAP * unitX,
        transition: SIDE_BAR_TRANSITION,
        textAlign: "left"
      }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={SIDE_BAR_ACCENT_WIDTH}
        height={SIDE_BAR_GROUP_ICON_SIZE}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={isActive ? colors.all.bondiBlue : colors.all.transparent}
        style={{
          flexShrink: 0,
          borderRadius: SIDE_BAR_ACCENT_RADIUS * unitX,
          transition: SIDE_BAR_TRANSITION
        }}
        onClick={() => {}}
      />
      <FontAwesomeIcon
        icon={icon}
        color={isActive ? colors.all.bondiBlue : contentColor}
        style={{
          width: SIDE_BAR_GROUP_ICON_SIZE * unitX,
          height: SIDE_BAR_GROUP_ICON_SIZE * unitY,
          flexShrink: 0,
          transition: SIDE_BAR_TRANSITION
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={SIDE_BAR_GROUP_FONT_SIZE}
        text={title}
        isSpan={false}
        color={contentColor}
        style={{
          margin: 0,
          textAlign: "left",
          flexGrow: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      />
      {!hasChevron || isNullOrUndefined(isOpen) ? null : (
        <FontAwesomeIcon
          icon={faChevronDown}
          color={contentColor}
          style={{
            width: SIDE_BAR_CHEVRON_SIZE * unitX,
            height: SIDE_BAR_CHEVRON_SIZE * unitY,
            flexShrink: 0,
            transform: isOpen ? CHEVRON_OPEN_ROTATION : CHEVRON_CLOSED_ROTATION,
            transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1)"
          }}
        />
      )}
    </button>
  );
});
export default SideBarRow;
